import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { User } from '@models';
import { Router, RouterLink } from '@angular/router';
import { appstraxAuth, AuthStatus } from '@appstrax/services/auth';
import { AuthResult } from '@appstrax/services/auth/models/auth_result';
import { WorkspaceFacade, UserFacade } from '@state';
import { ToastService } from '@services';
import { mapAuthErrorMessage } from '../../../utils/auth-error.util';
import { navigateAfterAuthentication } from '../../../utils/auth-entry.util';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.page.html',
  styleUrls: ['./sign-up.page.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
})
export class SignupPage implements OnInit {
  private userStore = inject(UserFacade);
  private router = inject(Router);
  private workspace = inject(WorkspaceFacade);
  private toast = inject(ToastService);

  user: User = new User();
  errorMessage: string = '';
  isLoading: boolean = false;

  async ngOnInit(): Promise<void> {
    if (await appstraxAuth.isAuthenticated()) {
      await navigateAfterAuthentication(this.router, this.workspace, this.toast);
    }
  }

  public async register() {
    if (!this.isFormValid()) {
      this.errorMessage = 'Please enter all fields';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    try {
      const result: AuthResult = await appstraxAuth.register({
        email: this.user.email,
        password: this.user.password,
        data: {
          name: this.user.name,
          surname: this.user.surname,
          profilePictureUrl: '',
          cvPdfUrl: '',
          linkedinUrl: '',
          githubUrl: '',
          twitterUrl: '',
          facebookUrl: '',
          instagramUrl: '',
          youtubeUrl: '',
          tiktokUrl: '',
        },
      });
      if (result.status == AuthStatus.authenticated) {
        this.userStore.setCurrentFromAuthUser(result.user!);
        await appstraxAuth.sendEmailVerificationCode();
        this.router.navigate(['/verify-email']);
      }
    } catch (error: any) {
      this.errorMessage = mapAuthErrorMessage(error);
    } finally {
      this.isLoading = false;
    }
  }

  public isFormValid() {
    return (
      this.user.name != '' &&
      this.user.surname != '' &&
      this.user.email != '' &&
      this.user.password != ''
    );
  }
}
